import React from 'react'
import { FlightGroupResult } from '../../api'

interface FlexibleDateTabsProps {
  groupedFlights: FlightGroupResult[]
  selectedDate: string
  onDateSelect: (date: string) => void
}

const FlexibleDateTabs: React.FC<FlexibleDateTabsProps> = ({
  groupedFlights,
  selectedDate,
  onDateSelect,
}) => {
  const formatTabDate = (dateString: string): string => {
    const date = new Date(dateString)
    const month = String(date.getMonth() + 1).padStart(2, '0')
    const day = String(date.getDate()).padStart(2, '0')
    return `${month}-${day}`
  }

  const getLowestPrice = (group: FlightGroupResult): number => {
    if (!group.flights || group.flights.length === 0) return 0

    return Math.min(
      ...group.flights.map(flight => {
        const totalFare = flight.journeys.reduce((sum, journey) => {
          return sum + (journey.fares?.totalFare || 0)
        }, 0)
        return totalFare
      }),
    )
  }

  return (
    <div
      style={{
        display: 'flex',
        gap: '8px',
        marginBottom: '16px',
        overflowX: 'auto',
        scrollBehavior: 'smooth',
        paddingBottom: '4px',
      }}
    >
      {groupedFlights.map(group => {
        const isSelected = group.departureDate === selectedDate
        const lowestPrice = getLowestPrice(group)

        return (
          <button
            key={group.departureDate}
            onClick={() => onDateSelect(group.departureDate)}
            style={{
              minWidth: '120px',
              padding: '12px 16px',
              border: isSelected
                ? '2px solid var(--vela-primary-color)'
                : '1px solid var(--vela-border-color)',
              borderRadius: '6px',
              backgroundColor: isSelected ? 'var(--vela-primary-color)' : 'white',
              color: isSelected ? 'white' : 'var(--vela-text-color)',
              cursor: 'pointer',
              fontSize: '14px',
              fontWeight: isSelected ? 'bold' : 'normal',
              whiteSpace: 'nowrap',
              transition: 'all 0.2s ease',
            }}
          >
            <div>{formatTabDate(group.departureDate)}</div>
            <div style={{ fontSize: '12px', marginTop: '4px' }}>
              {lowestPrice > 0 ? `₩${lowestPrice.toLocaleString()}원` : ''}
            </div>
          </button>
        )
      })}
    </div>
  )
}

export default FlexibleDateTabs
